import React from 'react';
import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';

interface PrivateRouteProps {
  children: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const { user, loading } = useAuth();
  const { t } = useTranslation();

  console.log('PrivateRoute: 인증 상태 확인', { user: user?.email, loading });

  if (loading) {
    console.log('PrivateRoute: 로딩 중');
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '200px', 
        fontSize: '16px', 
        color: '#666' 
      }}>
        {t('common.loading')}
      </div>
    );
  }

  if (!user) {
    console.log('PrivateRoute: 인증되지 않음, 로그인 페이지로 리다이렉트');
    return <Navigate to="/login" replace />;
  }

  console.log('PrivateRoute: 인증됨, 컴포넌트 렌더링');
  return <>{children}</>;
};

export default PrivateRoute; 